<template>
  <section class="manage-sidebar mr-12 pr-4">
    <ul
      v-if="this.$store.state.role === constants.DeveloperRoles.PARTNER_ADMIN"
      class="mt-4"
    >
      <li>
        <router-link
          :to="{name: 'Users'}"
        >Manage users</router-link>
      </li>
      <li>
        <router-link
          :to="{name: 'Credentials'}"
        >Manage credentials</router-link>
      </li>
      <li>
        <router-link
          :to="{name: 'BillsView'}"
        >View bills</router-link>
      </li>
    </ul>

    <ul
      v-if="this.$store.state.role === constants.DeveloperRoles.GLOBAL_ADMIN"
      class="mt-4"
    >
      <li>
        <router-link
          :to="{name: 'Partners'}"
        >Manage partners</router-link>
      </li>
    </ul>
  </section>
</template>

<script>
import constants from 'august-constants';

export default {
  name: 'ManageSidebar',
  data: () => {
    return {
      constants,
    };
  },
};
</script>

<style lang="scss">
.manage-sidebar {
  border-right: 1px solid #ccc;
  min-width: 11rem;

  ul {
    list-style-type: none;
    padding-left: 0;

    li {
      padding-bottom: 1rem;
      border-bottom: 2px solid #eee;
      margin-bottom: 1rem;
    }
  }
}

.router-link-active {
  color: black !important;
}
</style>
